import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'

import LoadingScreen from '../components/LoadingScreen'

import { fetchCurrentUser } from '../routes/login/reducers/loginReducer'

import { getNotifications } from '../routes/notifications/reducers/notificationsReducer'

const WithAuth = (WrappedComponent) => {
  class AuthorizedComponent extends Component {
    state = {
      loading: false,
    }

    componentDidMount = () => {
      if (localStorage.getItem('jwt') && this.props.loggedIn) {
        this.props.getNotifications()
      }

      if (localStorage.getItem('jwt') && !this.props.loggedIn) {
        this.setState({ loading: true })
        this.props.fetchCurrentUser(this.props.routerProps.match.url)
      }
    }

    render() {
      if (localStorage.getItem('jwt') && this.props.loggedIn) {
        return <WrappedComponent {...this.props} />
      } else if (this.state.loading) {
        return <LoadingScreen text="Loading" />
      } else {
        // RELIES ON HASH ROUTER BEING USED SINCE IT'S SPLITING BY #
        const currentPath = window.location.href.split("#")[1]
        return (
          // <Redirect to='/login' />
          <Redirect
            to={{
              pathname: "/login",
              state: { referrer: currentPath }
            }}
          />
        )
      }
    }

  }

  const mapStateToProps = (state) => {
    return {
      loggedIn: state.loginReducer.loggedIn,
      authenticatingUser: state.loginReducer.authenticatingUser,
      currentUser: state.loginReducer.currentUser
    }
  }

  return connect(mapStateToProps, { fetchCurrentUser, getNotifications })(AuthorizedComponent)

}

export default WithAuth
